import React from 'react';
import { GamesListComponent } from './casino_section_components';

export default (props) => (
  <GamesListComponent
    {...props}
    useLargeImages
    orientation="vertical"
    className="right-sidebar-components__casino-games-list"
  />
);
